import { Component } from '@angular/core';


@Component({
    selector: 'ui-toolbar',
    host: {
        class: 'bg-white border-bottom px-4 py-2',
    },
    styles: [
        `
        :host {
            display: flex;
            align-items: center;
        }

        :host ::ng-deep .btn.btn-ui-toolbar {
            border: 1px solid var(--normal);
            background: none;
            color: var(--normal);
        }

        :host ::ng-deep .btn {
            margin-left: 3px;
        }

        :host ::ng-deep .vertical-divider {
            border-right: 1px solid #D8E7F0;
            height: 30px;
            margin-left: 20px;
        }
        `,
    ],
    template: `
        <ng-content></ng-content>
    `,
})
export class ToolbarComponent {}
